module.exports = __webpack_public_path__ + "img/attack_windy.697e23fb.png";